module.exports = __webpack_public_path__ + "static/img/people.665094ec.svg";